import Yup from "../mixins/yup";

const REQUIRED_MESSAGE = "Campo obrigatório";

export const hospitalizationFilterValidationSchema = Yup.object().shape({
	startDate: Yup.date().required(REQUIRED_MESSAGE),
	endDate: Yup.date().required(REQUIRED_MESSAGE),
    department: Yup.object().shape({
        label: Yup.string().required(REQUIRED_MESSAGE),
    }),
    hospitalWard: Yup.object().shape({
        label: Yup.string().required(REQUIRED_MESSAGE),
    }),
});